<script lang="ts" setup>
import type { ApiResponse } from '#open-fetch'

const model = defineModel<number>({ required: true })

withDefaults(defineProps<{
  meta?: Omit<ApiResponse<'games.index'>['meta'], 'links'>
  withoutNumbers?: boolean
}>(), {
  withoutNumbers: false,
})
</script>

<template>
  <div
    v-if="meta && meta.total > meta.per_page"
    class="w-full flex justify-center py-4 max-w-full overflow-auto"
  >
    <UiPagination
      v-model:page="model"
      :total="meta.total"
      :sibling-count="1"
      :items-per-page="meta.per_page"
    >
      <UiPaginationList
        v-slot="{ items }"
        class="flex items-center gap-1"
      >
        <UiPaginationFirst />
        <UiPaginationPrev />

        <template v-if="!withoutNumbers">
          <template v-for="(item, index) in items">
            <UiPaginationListItem
              v-if="item.type === 'page'"
              :key="index"
              :value="item.value"
              as-child
            >
              <UiButton
                class="w-10 h-10 p-0"
                :variant="item.value === model ? 'default' : 'outline'"
              >
                {{ item.value }}
              </UiButton>
            </UiPaginationListItem>
            <UiPaginationEllipsis
              v-else
              :key="item.type"
              :index="index"
            />
          </template>
        </template>

        <UiPaginationNext />
        <UiPaginationLast />
      </UiPaginationList>
    </UiPagination>
  </div>
</template>
